export default __webpack_public_path__ + "static/media/go_doc_action.18dc4031.svg";